import { useCallback } from "react";
import { showModal } from "../../../../../common-deprecated/redux/actions/ModalActions";
import { getTagContent, getTagRegExp } from "../../../../../common-deprecated/utils";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../redux/store";
import { MODAL_MASS_MANAGEMENT } from "../../utils/modalConstants";
import { isMassValidationOk } from "../../utils/typedUtils";
import { useBnbOptionalLabel } from "../../utils/labels";
import { useDispatch } from "../../../../../shared-logic/redux/store";

type DataType = {
    visible: boolean;
    labels?: {
        start: string;
        link: string;
        end: string;
    };
    openMassManagementModal: (event: React.MouseEvent) => void;
};

const useBasketMassManagement = (): DataType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const massManagement = useBnbSelector((state) => state.massManagement);
    const notificationLabel = useBnbOptionalLabel("massManagementBasketNotification");
    const errorLabel = useBnbOptionalLabel("massManagementErrorMessage");

    const openMassManagementModal = useCallback((event: React.MouseEvent) => {
        event.preventDefault();
        dispatch(showModal({ type: MODAL_MASS_MANAGEMENT }, 1));
    }, []);

    let basketLabel = "";
    let labels;

    const error = massManagement.error && !!errorLabel;

    const visible = (!isMassValidationOk(massManagement) && !!notificationLabel) || !!error;

    if (error) {
        labels = {
            start: errorLabel!,
            link: "",
            end: "",
        };
    } else if (visible) {
        basketLabel = notificationLabel!.replace("{value}", String(massManagement.exceedingKilogram));
        const labelSections = basketLabel.split(getTagRegExp("button"));
        labels = {
            start: labelSections[0],
            link: basketLabel ? getTagContent("button", basketLabel) : "",
            end: labelSections.length > 2 ? labelSections[2] : "",
        };
    }

    return {
        visible,
        labels,
        openMassManagementModal,
    };
};

export default useBasketMassManagement;
